module.exports = "//static.hsappstatic.net/LoginUI/static-1.14890/img/login-marketing-image.png"